import { AnyAction } from "redux"
import { UIState } from "../../types/state/ui/UIState"
import { tableInitialState, tableReducer } from "./table.reducer"
import { accountActions } from "../../constants";
import { ActionType } from "typesafe-actions";
import { tableActions } from "../../actions/ui/table.actions";
import { popupOrderInitialState, popupOrderReducer } from "./popup-order.reducer";
import { popupOrderActions } from "../../actions/ui/popup-order.actions";

const initialState: UIState = {
    table: tableInitialState,
    popupOrder: popupOrderInitialState
}

export const ui = (state = initialState, action: AnyAction): UIState => {
    if (action.type === accountActions.LOGOUT) return { ...initialState };

    const [branch, feature] = action.type.split('/');

    if (branch !== 'ui') {
        return state;
    }

    switch (feature) {
        case 'table':
            return {
                ...state,
                table: tableReducer(state.table, action as ActionType<typeof tableActions[keyof typeof tableActions]>)
            }
        case 'popup-order':
            return {
                ...state,
                popupOrder: popupOrderReducer(state.popupOrder, action as ActionType<typeof popupOrderActions[keyof typeof popupOrderActions]>)
            }
        default: return state;
    }
}
